import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  GetenabledLeave,
  HEADERS,
  getLeaPId,
  getDepId,
  getUserId,
  submitLeaveRequest,
  GetLeaveType,
  getOrgId,
  GetUser,
  submitforothers,
} from "../api";

function UserApproval() {
  const [activeSelf, setActiveSelf] = useState(true);
  const [activeOthers, setActiveOthers] = useState(false);
  const [showSelf, setShowSelf] = useState(true);
  const [showOthers, setShowOthers] = useState(false);
  const [leaPId, setLeaPId] = useState([]);
  const [leaveType, setLeaveType] = useState([]);
  const [otherLeaveType, setOtherLeaveType] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [isHalfDaySelf, setIsHalfDaySelf] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const isStandalone = true;
  const navigate = useNavigate();
  const currentUserId = localStorage.getItem("user_id");
  const filteredEmployeeList = employeeList.filter(
    (emp) => emp.user_id !== currentUserId
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestData = { lp_id: getLeaPId() };
        const response = await axios.post(GetenabledLeave, requestData, {
          headers: HEADERS,
        });
        console.log("Leave Types:", response.data);
        if (response.data.response_code === "0000") {
          setOtherLeaveType(response.data.data);
        } else {
          console.error("Error fetching Leave Enabled.");
        }
      } catch (error) {
        console.error("Error fetching Leave Enabled:", error);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    const fetchgetallData = async () => {
      const OrgID = getOrgId();
      try {
        const requestData = { org_id: OrgID };
        const response = await axios.post(GetLeaveType, requestData, {
          headers: HEADERS,
        });
        console.log("response:", response.data);

        if (response.data.response_code === "0000") {
          setOtherLeaveType(response.data.data);
        } else {
          // console.error("Error fetching leave type. Please try again later.");
        }
      } catch (error) {
        // console.error("An error occurred while fetching leave type:", error);
      }
    };
    fetchgetallData();
  }, []);

  useEffect(() => {
    const fetchuserData = async () => {
      const OrgID = getOrgId();
      const DepId = getDepId();

      try {
        const requestData = { org_id: OrgID, dept_id: DepId };
        const response = await axios.post(GetUser, requestData, {
          headers: HEADERS,
        });
        console.log("response:", response.data);

        if (response.data.response_code === "0000") {
          setEmployeeList(response.data.data);
        } else {
          console.error("Error fetching leave type. Please try again later.");
        }
      } catch (error) {
        console.error("An error occurred while fetching leave type:", error);
      }
    };
    fetchuserData();
  }, []);

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      try {
        if (!isStandalone) return;

        const leavePolicyId = getLeaPId();

        if (!leavePolicyId) {
          console.warn("No leave policy ID found in localStorage.");
          return;
        }

        const requestData = { lp_id: leavePolicyId };

        const response = await axios.post(GetenabledLeave, requestData, {
          headers: HEADERS,
        });

        if (response.data.response_code === "0000") {
          setLeaveType(response.data.data);
        } else {
          console.error("Failed to fetch leave types for standalone.");
          setLeaveType([]);
        }
      } catch (error) {
        console.error("Error fetching leave types for standalone:", error);
        setLeaveType([]);
      }
    };

    fetchLeaveTypes();
  }, [isStandalone]);

  const handleSelfClick = () => {
    setActiveSelf(true);
    setActiveOthers(false);
    setShowSelf(true);
    setShowOthers(false);
  };

  const goToLeaveNavigation = () => {
    navigate("/leave-navigation");
    setTimeout(() => {
      window.location.reload();
    }, 50);
  };
  const Submit = () => {
    let isEmpty = false;

    if (activeSelf) {
      if (
        !ApiData.leave_type ||
        !ApiData.begin_date ||
        !ApiData.end_date ||
        !ApiData.leave_description
      ) {
        isEmpty = true;
      }
    } else {
      if (
        !othersApiData.requested_for ||
        !othersApiData.leave_type ||
        !othersApiData.begin_date ||
        !othersApiData.end_date ||
        !othersApiData.leave_description
      ) {
        isEmpty = true;
      }
    }

    if (isEmpty) {
      Swal.fire({
        icon: "error",
        title: "Missing Information",
        text: "Please fill in all the fields.",
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });
    } else {
      Swal.fire({
        title: "Submit Confirmation",
        text: "Are you sure you want to submit?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "grey",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Submit",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          if (activeSelf) {
            Leave_Request();
          } else {
            Leave_others();
          }
          goToLeaveNavigation();
        }
      });
    }
  };
  const handleLeaveDescriptionChange = (e) => {
    const newLeaveDescription = e.target.value;
    setPostData({ ...ApiData, leave_description: newLeaveDescription });
  };

  const handleLeaveDescriptionChangeothers = (e) => {
    const newLeaveDescription = e.target.value;
    setothersPostData({
      ...othersApiData,
      leave_description: newLeaveDescription,
    });
  };

  const handleOthersClick = () => {
    setActiveSelf(false);
    setActiveOthers(true);
    setShowSelf(false);
    setShowOthers(true);
  };
  const UserId = getUserId();
  const [ApiData, setPostData] = useState({
    requested_by: UserId,
    leave_type: "",
    begin_date: "",
    end_date: "",
    half_days: isHalfDaySelf,
    days_off: 0,
    leave_description: "",
    document: "",
  });

  useEffect(() => {
    setPostData((prevData) => ({
      ...prevData,
      half_days: isHalfDaySelf,
    }));
  }, [isHalfDaySelf]);
  const handleCheckboxSelfChange = (event) => {
    setIsHalfDaySelf(event.target.checked);
  };
  const Leave_Request = async () => {
    try {
      const response = await axios.post(submitLeaveRequest, ApiData, {
        headers: HEADERS,
      });
      console.log("er", response);
      if (response.data.response_code === "0000") {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `${response.data.response_description}`,
          confirmButtonColor: "#2D7D9F",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: `${response.data.response_description}`,
          confirmButtonColor: "#2D7D9F",
        });
      }
    } catch (error) {
      console.error("Error posting data:", error);
      if (error.response && error.response.data) {
      }
      Swal.fire("Failed!", "Something went wrong! Please try again!", "error");
    }
  };

  const [isHalfDayOthers, setIsHalfDayOthers] = useState(false);
  const [othersApiData, setothersPostData] = useState({
    requested_by: UserId,
    requested_for: "",
    leave_type: "",
    begin_date: "",
    end_date: "",
    half_days: isHalfDayOthers,
    days_off: 0,
    leave_description: "",
    document: "",
  });

  useEffect(() => {
    setothersPostData((prevData) => ({
      ...prevData,
      half_days: isHalfDayOthers,
    }));
  }, [isHalfDayOthers]);
  const handleCheckboxForOther = (event) => {
    setIsHalfDayOthers(event.target.checked);
  };
  const Leave_others = async () => {
    try {
      const response = await axios.post(submitforothers, othersApiData, {
        headers: HEADERS,
      });
      if (response.data.response_code === "0000") {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `${response.data.response_description}`,
          confirmButtonColor: "#2D7D9F",
        }).then((result) => {
          navigate("/leave-navigation");
        });
      } else {
        if (response.data && response.data.errors) {
        }
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: `${response.data.response_description}`,
          confirmButtonColor: "#2D7D9F",
        }).then((result) => {
          navigate("/leave-navigation");
        });
      }
    } catch (error) {
      console.error("Error posting data:", error);
      if (error.response && error.response.data) {
      }
      Swal.fire("Failed!", "Something went wrong! Please try again!.", "error");
    }
  };

  const [inputType, setInputType] = useState("text");
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "Casual") {
      setInputType("text");
    } else if (selectedValue === "Annual") {
      setInputType("text");
    } else if (selectedValue === "Paternity") {
      setInputType("text");
    } else if (selectedValue === "Bereavement") {
      setInputType("text");
    } else if (selectedValue === "Medical") {
      setInputType("file");
    }
  };

  return (
    <div className="">
      <div>
        <span className="breadcrumb d-flex gap-2">
          <Link
            className="previou-link text-decoration-none"
            to="/leave-navigation"
          >
            Leave
          </Link>
          <span>/</span>
          <Link className="current-link text-decoration-none">
            {" "}
            Add Request
          </Link>
        </span>
      </div>
      <h5 className="title">Request Form</h5>
      <div className="border rounded mt-3 p-3">
        <div className="background text-center">
          <button
            className={`apply-self ${activeSelf ? "active-button" : ""}`}
            onClick={handleSelfClick}
            style={{
              backgroundColor: activeSelf ? "#2d7d9f" : "",
              color: activeSelf ? "white" : "",
            }}
          >
            Self
          </button>
          <button
            className={`apply-others ${activeOthers ? "active-button" : ""}`}
            onClick={handleOthersClick}
            style={{
              backgroundColor: activeOthers ? "#2d7d9f" : "",
              color: activeOthers ? "white" : "",
            }}
          >
            Others
          </button>
        </div>
        <div
          className={`row mt-3 self justify-content-center ${
            showSelf ? "" : "d-none"
          }`}
        >
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="">Choose Leave Type</label>
              <select
                className="form-select"
                onChange={(e) => {
                  handleSelectChange(e);
                  setPostData({ ...ApiData, leave_type: e.target.value });
                }}
                value={ApiData.leave_type || ""}
              >
                <option value="" disabled hidden>
                  Select Leave Type
                </option>
                {(leaveType || []).map((type) => (
                  <option key={type.leave_type_id} value={type.leave_type_id}>
                    {type.leave_type_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mt-2">
              <label>From Date</label>
              <input
                className="form-control"
                type="date"
                min={new Date().toISOString().split("T")[0]}
                onChange={(e) =>
                  setPostData({ ...ApiData, begin_date: e.target.value })
                }
              />
            </div>

            <div className="form-group mt-2">
              <label>To Date</label>
              <input
                className="form-control"
                type="date"
                min={new Date().toISOString().split("T")[0]}
                onChange={(e) =>
                  setPostData({ ...ApiData, end_date: e.target.value })
                }
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group textarea">
              <span>Reason</span> <br />
              <textarea
                style={{ height: "120px" }}
                className="form-control"
                type={inputType}
                value={ApiData.leave_description}
                onChange={handleLeaveDescriptionChange}
              />
            </div>
            <div
              className="form-group mt-3"
              style={{ display: "flex", alignItems: "center" }}
            >
              <label htmlFor="isVendor" style={{ marginBottom: "14px" }}>
                Half Day
              </label>
              <input
                type="checkbox"
                id="isVendor"
                checked={isHalfDaySelf}
                onChange={handleCheckboxSelfChange}
                style={{
                  width: "20px",
                  height: "20px",
                  marginLeft: "auto",
                  marginTop: "5px",
                }}
              />
            </div>
          </div>
          <div className="d-flex">
            <button className=" ms-auto mt-4 button-outline" onClick={Submit}>
              Submit
            </button>
          </div>
        </div>

        <div
          className={`row mt-3 others justify-content-center ${
            showOthers ? "" : "d-none"
          }`}
        >
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="">Choose Employee</label>
              <select
                className="form-select"
                value={othersApiData.requested_for}
                onChange={async (e) => {
                  const selectedId = e.target.value;

                  setothersPostData({
                    ...othersApiData,
                    requested_for: selectedId,
                  });

                  const selectedEmp = employeeList.find(
                    (emp) => emp.user_id === selectedId
                  );

                  if (selectedEmp) {
                    setSelectedEmployee(selectedEmp);

                    try {
                      const requestData = { lp_id: selectedEmp.leave_policy };
                      const response = await axios.post(
                        GetenabledLeave,
                        requestData,
                        { headers: HEADERS }
                      );

                      if (response.data.response_code === "0000") {
                        setOtherLeaveType(response.data.data);
                      } else {
                        console.error("Error fetching leave types");
                        setOtherLeaveType([]);
                      }
                    } catch (error) {
                      console.error("API Error for leave type fetch:", error);
                      setOtherLeaveType([]);
                    }
                  }
                }}
              >
                <option value="" disabled>
                  Select Employee Name
                </option>
                {filteredEmployeeList.map((employee) => (
                  <option key={employee.user_id} value={employee.user_id}>
                    {employee.first_name} {employee.last_name} (
                    {employee.employee_code})
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mt-2">
              <label htmlFor="">Choose Leave Type</label>
              <select
                className="form-select"
                onChange={(e) => {
                  handleSelectChange(e);
                  setothersPostData({
                    ...othersApiData,
                    leave_type: e.target.value,
                  });
                }}
                value={othersApiData.leave_type || ""}
                disabled={
                  !othersApiData.requested_for || otherLeaveType.length === 0
                }
              >
                <option value="" disabled hidden>
                  Select Leave Type
                </option>
                {(otherLeaveType || []).map((type) => (
                  <option key={type.leave_type_id} value={type.leave_type_id}>
                    {type.leave_type_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mt-2">
              <label>From Date</label>
              <input
                className="form-control"
                type="date"
                min={new Date().toISOString().split("T")[0]}
                onChange={(e) =>
                  setothersPostData({
                    ...othersApiData,
                    begin_date: e.target.value,
                  })
                }
              />
            </div>
            <div className="form-group mt-2">
              <label>To Date</label> <br />
              <input
                className="form-control"
                type="date"
                min={new Date().toISOString().split("T")[0]}
                onChange={(e) =>
                  setothersPostData({
                    ...othersApiData,
                    end_date: e.target.value,
                  })
                }
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group textarea">
              <label>Reason</label> <br />
              <textarea
                className="form-control"
                type={inputType}
                value={othersApiData.leave_description}
                onChange={handleLeaveDescriptionChangeothers}
                style={{ height: "120px" }}
              />
            </div>
            <div
              className="form-group mt-3"
              style={{ display: " flex", alignItems: "center" }}
            >
              <label htmlFor="isOtherHalfDay" style={{ marginBottom: "14px" }}>
                Half Day
              </label>
              <input
                type="checkbox"
                id="isOtherHalfDay"
                checked={isHalfDayOthers}
                onChange={handleCheckboxForOther}
                style={{
                  width: "20px",
                  height: "20px",
                  marginLeft: "auto",
                  marginTop: "5px",
                }}
              />
            </div>
          </div>
          <div className="d-flex">
            <button className="ms-auto button-outline mt-4" onClick={Submit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserApproval;
